<template>
  <div class="detail">
    <div class="circle-card" v-if="info">
      <div class="circle-info-top">
        <van-image :src="info.iconUrl" lazy-load class="circle-logo" @click.stop="() => preViewImage(0)"/>
        <div>
          <div class="circle-title">
            {{info.name}}
          </div>
          
          <div >
            <div class="circle-info-warp">
              
              <div class="view-info">
                  <span>{{total}} 篇文章 · {{info.favorNum}} 人关注</span>
              </div>
            </div>
            <div class="circle-operate">
              <div
              v-if="!info.isOwner"
              round
              class="favor-btn"
              @click="updateCircleFavor"
              type="default">
              {{info.isFavor ? '已关注' : '关注'}}
            </div>
            <div
                class="favor-btn"
                @click="handleShare"
                type="default">
                <img style="width: 12px;height: 11px;margin-right: 4px" src="../../assets/share.png"/>
                分享
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="title-warp">
        
        <van-button
          v-if="!info.isOwner"
          size="small"
          round
          class="favor-btn"
          @click="updateCircleFavor"
          type="default">
          {{info.isFavor ? '已订阅' : '订阅'}}
        </van-button>
      </div> -->
      <div class="circle-owners">
        <div class="owners-label">管理员：</div>
        <div class="info">
            <span
              v-for="owner in info.ownerList"
              :key="owner.userId"
              class="user"
            >
              <div class="avatar">
                <img class="avatar-icon" :src="owner.iconUrl"/>
                <FansPendant v-if="owner.userId" :userId="owner.userId"/>
              </div>
              <span>{{owner.realName}}</span>
            </span>
          </div>
      </div>
      <div class="intro">
        {{info.intro}}
      </div>

      
    </div>
     <van-sticky>
    <van-tabs
      v-model="active"
      title-active-color="#ee0a24"
      style="position:relative;top:-1px;"
      >
      <van-tab
        v-for="item in tabList"
        :key="item.type"
        :name="item.type"
        :title="item.name">
        </van-tab>
    </van-tabs>
    </van-sticky>
    <van-pull-refresh
      v-if="articleList.length || loading"
      v-model="refreshing"
      @refresh="onRefresh"
      success-text="刷新成功">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <ArticleCard
          v-for="item in articleList"
          :key="item.id"
          @refresh="handleRefresh"
          timeField="createTime"
          :rowData="item"
        />
      </van-list>
    </van-pull-refresh>
  </div>
</template>
<script>
import api from '../../api';
import { getDateDiff } from '../../utils/lib';
// import ColumnCard from '../../components/columnCard.vue';
import ArticleCard from '../article/components/card.vue';
import { mapActions, mapState } from 'vuex';
import { ImagePreview } from 'vant';
import FansPendant from '../../components/fansPendant.vue';
export default {
  components: {
    // ColumnCard,
    ArticleCard,
    FansPendant
  },
  data() {
    return {
      info: null,
      getDateDiff,
      pageParams: {
        page: 1,
        pageSize: 10
      },
      articleList: [],
      loading: false,
      finished: false,
      refreshing: false,
      active: '0',
      total: 0,
      tabList: [
        {
          name: '文章',
          type: '0'
        },
        {
          name: '畅聊',
          type: '1'
        }
      ]
    }
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    refreshFlag() {
      return this.$route.params.refreshFlag;
    },
    ...mapState(['userInfo'])
  },
  watch: {
    active: {
      handler() {
        this.onRefresh();
      }
    },
    id: {
      handler(_id, old) {
        console.log(_id, old)
      },
    }
  },
  mounted() {
    this.init();
    this.handleBack();
  },
  activated() {
    if (this.refreshFlag) {
      this.init();
    }
  },
  methods: {
    ...mapActions(['updateUserInfoList']),
    init() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.finished = false;
      this.pageParams.page = 1;
      this.info =  null;
      this.articleList = [];
      this.getCircleInfo();
      this.getCircleArticleList();
    },
    handleBack() {
      const _this = this
      let options = {
        disabled: true,
        callback: function() {
          if (window.history.length > 1) {
            _this.$router.go(-1)
          } else {
            _this.$router.replace({ name: 'articleList' })
          }
        }
      }
      window.jme.browser.setGoBackDisabled(options)
    },
    preViewImage(index) {
      ImagePreview([this.info.iconUrl], index)
    },
    updateCircleFavor() {
      api.updateCircleFavor(this.id).then(({code}) => {
        if (code === 200) {
          this.info = {
            ...this.info,
            isFavor: this.info.isFavor === 1 ? 0 : 1,
            favorNum: this.info.isFavor === 1 ? this.info.favorNum - 1 : this.info.favorNum + 1
          }
        }
      })
    },
    handleShare() {
      const { name, intro, id, } = this.info
      const shareId = this.$route.query.shareId ? this.$route.query.shareId : this.userInfo.id;
      const url = `http://sd.jd.com/circle/${id}?shareId=${shareId}&isHideShareButton=1`
      const options = {
        shareData: {
          title: name,
          content: intro,
          url,
          icon: 'https://s3.cn-north-1.jdcloud-oss.com/shendengbucket1/2023-02-28-17-07uAVeSgG0YYEUaxf.png',
        },
        typeList: ['JDMESession', 'CopyLink'],
        callback: function() {}
      }
      window.jme.share.shareCustom(options)
    },
    getCircleInfo() {
      api.getCircleInfo({
        id: this.id
      }).then((res) => {
        const { code, data } = res;
        if (code === 200) {
          this.info = data;
          const userIds = data?.ownerListPro?.map((item) => item.userId);
          if (userIds?.length) {
            this.updateUserInfoList(userIds.join())
          }
        }
      })
    },
    getCircleArticleList() {
      this.loading = true
      api.getCircleArticleList({
        ...this.pageParams,
        type: this.active,
        forumId: this.id
      }).then((res) => {
        const {code, data, totalCount} = res;
        if (this.active === '0') {
          this.total = totalCount;
        }
        this.loading = false
        if (this.refreshing) {
          this.refreshing = false
        }
        if (code === 200) {
          const userIds = data?.map((item) => item.userId);
          if (userIds?.length) {
            this.updateUserInfoList(userIds.join())
          }
          if (this.pageParams.page > 1) {
            this.articleList = this.articleList.concat(data)
          } else {
            this.articleList = data
          }
          if (this.articleList.length >= totalCount) {
            this.finished = true
          }
        }
      })
    },
    onLoad() {
      this.pageParams.page++
      this.getCircleArticleList()
    },
    onRefresh() {
      this.finished = false
      this.pageParams.page = 1 
      this.getCircleArticleList()
    },
    handleRefresh(val, type) {
      if (val) {
        if (type === 'share') {
          this.articleList = this.articleList.map(item => {
          if (item.id === val.id) {
            item = Object.assign(item, { sharedNum: val.sharedNum })
          }
          return item
        })
          return;
        }
        let up
        let upNum
        if (val.isUp === '踩') {
          up = val.isUp === '踩' ? -1 : 1
          upNum = val.upNum
        } else {
          up = val.isUp === 1 ? -1 : 1
          upNum = val.isUp === 1 ? val.upNum - 1 : val.upNum + 1 
        }
        this.articleList = this.articleList.map(item => {
          if (item.id === val.id) {
            item = Object.assign(item, { isUp: up, upNum })
          }
          return item
        })
      } else {
        this.getCircleArticleList()
      }
    },
  }
}
</script>
<style lang="less" scoped>
.detail {
  // padding-top: 10px;
}
.circle-card {
  padding: 10px;
  border-radius: 4px;
  text-align: left;
  background: #faf7eb;


}
.circle-info-top {
  display: flex;
}
.circle-top {
  display: flex;
  align-items: center;
}

.circle-logo {
  width: 80px;
  height: 80px;
  // height: 70px;
  border: 1px solid #f0f0f2;
  margin-right: 8px;
}
.circle-info-warp {
  flex: 1;
  overflow: hidden;
  margin-left: 12px;
}
.title-warp {
  display: flex;
  align-items: flex-start;
  margin-bottom: 4px;
}
.circle-title {
  margin-left: 4px;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 8px;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;
}
.circle-operate {
  display: flex;
  align-items: center;
}
.favor-btn {
  padding: 0 8px;
  height: 24px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin-top: 2px;
  margin-left: 8px;
  background: #fff;
}
.info {
  font-size: 13px;
  margin-bottom: 4px;
  // color: #a5a3a3;
  display: flex;
  flex-wrap: wrap;
}
.view-info {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #bbb;
  &-left {
    display: flex;
    align-items: center;
    & > span {
      margin-right: 12px;
    }
  }
}
.intro {
  // margin: 10px 0;
  color: #666;

}
.user {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  margin: 0 12px 6px 0;
  .avatar-icon {
    height: 18px;
    width: 18px;
    border-radius: 50%;
    margin-right: 4px;
  }
}
.avatar {
  position: relative;
  display: flex;
  align-items: center;
}
.circle-owners {
  display: flex;
  align-items: flex-start;
  margin-top: 12px;
}
.owners-label {
  font-size: 13px;
  font-weight: bold;
  flex-shrink: 0;
}
</style>